import { render, staticRenderFns } from "./PointCurrentProgress.vue?vue&type=template&id=2edcff92&scoped=true&lang=pug&"
import script from "./PointCurrentProgress.vue?vue&type=script&lang=js&"
export * from "./PointCurrentProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edcff92",
  null
  
)

export default component.exports